import i18n from 'i18next';

type PageRun = {
  end: number;
  start: number;
};

/** Collapse sorted unique page numbers into consecutive runs. */
function getPageRuns(pages: number[]): PageRun[] {
  if (pages.length === 0) {
    return [];
  }

  const sorted = [...new Set(pages)].sort((a, b) => a - b);
  const runs: PageRun[] = [];
  let start = sorted[0];
  let prev = sorted[0];

  for (let index = 1; index <= sorted.length; index += 1) {
    const current = sorted[index];
    if (current !== prev + 1) {
      runs.push({ start, end: prev });
      start = current;
    }
    prev = current;
  }

  return runs;
}

function formatRunsLabel(runs: PageRun[]): string {
  return runs
    .map((run) =>
      run.start === run.end ? `${run.start}` : `${run.start}–${run.end}`
    )
    .join(', ');
}

/** Formats document page references (e.g. "p. 7", "pp. 3–4, 7", "S. 3–4, 7"). */
export function formatPageReferences(
  pages: number[] | undefined
): string | null {
  if (!pages || pages.length === 0) {
    return null;
  }

  const runs = getPageRuns(pages);
  if (runs.length === 0) {
    return null;
  }

  const pageCount = runs.reduce(
    (count, run) => count + (run.end - run.start + 1),
    0
  );

  return i18n.t('app.pageReference.reference', {
    count: pageCount,
    pages: formatRunsLabel(runs),
  });
}
